import { render } from "./TnvedCard.vue?vue&type=template&id=86473d68&scoped=true"
import script from "./TnvedCard.vue?vue&type=script&lang=js"
export * from "./TnvedCard.vue?vue&type=script&lang=js"

import "./TnvedCard.vue?vue&type=style&index=0&id=86473d68&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86473d68"]])

export default __exports__